const Steper = ({step, data}) => {

    const hasStep = data.some(s => s.key === step);

    return (
        <ol className="stepper" hidden={!hasStep}>
            {data.map(item => (
                <li key={item.id} className={step === item.key? "active animate_animated animate_backInRight" : "animate__animated animate__bounceOutRight"}>
                    {item.title}
                </li>
            ))}
        </ol>
    )
}
export default Steper;